import { Injectable, inject } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { routes } from '../../../app.routes';
import { Observable } from 'rxjs';
import { FooterService } from 'src/app/services/footer.service';
import { result } from 'lodash';

export function extractValidRoutes(): string[] {
  const langChildren = routes.find((r) => r.path === ':lang')?.children || [];
  return langChildren
    .map((r) => r.path)
    .filter((path): path is string => !!path && path !== '**'); // Ensures `path` is always a string
}
@Injectable({
  providedIn: 'root',
})
export class CustomRedirectGuard {
  private validRoutes: string[] = extractValidRoutes();
  private toggleTranslation: boolean = false;

  constructor(private router: Router, private footerService: FooterService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    let storedLang = localStorage.getItem('translocoLang') || 'el';
    this.footerService.toggleTranslation$.subscribe(result => {
      if (!result) {
        storedLang = 'el';
      }
    });


    // **Explicitly check if we are *under* the `:lang` route segment**
    if (route.routeConfig && route.routeConfig.path === ':lang') {
      // Check if routeConfig exists and path is ':lang'$
      const pathPartsArray = state.url.split('/').filter(Boolean)[1]; // Remove empty segments
      if (pathPartsArray === 'undefined' || pathPartsArray === undefined) {
        this.router.navigate([`${storedLang}${state.url}`]);
        return false;
      }

      // Ensure we get a valid enteredPath
      const enteredPath =
        state.url.split('/').filter(Boolean).length > 1
          ? state.url.split('/').filter(Boolean)[0]
          : 'home';

      if (this.validRoutes.includes(enteredPath)) {
        this.router.navigate([`/${storedLang}/${enteredPath}`]);
        return false;
      }
    }
    return true;
  }
}
